import React, { useState, useEffect } from "react";
import axios from "axios";
import Chart from "react-apexcharts";
import { REACT_APP_API_URL } from "../../../../env";
import { HEATMAP_MONTHS } from "./dashboardUtils";

export const AdminTopRevenueHotelsSection = ({ yearList = [] }) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [chartData, setChartData] = useState({ series: [], labels: [] });

  useEffect(() => {
    const fetchTopRevenueHotels = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/kpi/top-revenue-hotels`, {
          params: { month: selectedMonth, year: selectedYear }
        });

        if (res.data?.success && Array.isArray(res.data?.data) && res.data.data.length > 0) {
          const data = res.data.data;
          const series = [];
          const labels = [];

          data.forEach((item, index) => {
            const preferredNameKeys = [
              "hotelName",
              "HotelName",
              "hotel",
              "Hotel",
            ];
            const nameKey =
              preferredNameKeys.find((key) => key in item) ||
              Object.keys(item).find(
                (key) => key.toLowerCase().includes("name") || key.toLowerCase().includes("hotel"),
              ) ||
              "HotelName";
            const revenueKey = Object.keys(item).find(key => key.toLowerCase().includes("revenue") || key.toLowerCase().includes("amount") || key.toLowerCase().includes("total")) || "TotalRevenue";
            const hotelId = item.hotelId || item.HotelId || item.hotelID || item.HotelID;
            const hotelLabel = item[nameKey]?.toString().trim();

            labels.push(hotelLabel || (hotelId ? `Hotel ${hotelId}` : `Hotel ${index + 1}`));
            series.push(Number(item[revenueKey]) || 0);
          });

          setChartData({ series, labels });
        } else {
          setChartData({ series: [], labels: [] });
          setError("No data available for top revenue hotels.");
        }
      } catch (err) {
        console.error("Error fetching top revenue hotels:", err);
        setChartData({ series: [], labels: [] });
        setError("Failed to load top revenue hotels.");
      } finally {
        setLoading(false);
      }
    };

    fetchTopRevenueHotels();
  }, [selectedYear, selectedMonth]);

  const options = {
    chart: {
      type: "donut",
    },
    labels: chartData.labels,
    tooltip: {
      y: {
        formatter: (value) =>
          new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            maximumFractionDigits: 0,
          }).format(value),
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val, opts) => {
          return opts.w.globals.labels[opts.seriesIndex];
      }
    },
    legend: {
      position: "bottom",
    },
    theme: {
        palette: 'palette1'
    }
  };

  return (
    <div className="row g-3 mb-3 mt-1">
      <div className="col-md-12 col-lg-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center" >
            <h6 className="card-title mb-0">Top 4 Revenue Hotels ({HEATMAP_MONTHS[selectedMonth - 1]} {selectedYear})</h6>
            <div className="d-flex gap-2" >
              <select
                className="form-select form-select-sm"
                value={selectedYear}
                onChange={(e) => setSelectedYear(Number(e.target.value))}
                style={{ width: "100px" }}
              >
                {yearList.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
              <select
                className="form-select form-select-sm"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(Number(e.target.value))}
                style={{ width: "120px" }}
              >
                {HEATMAP_MONTHS.map((month, index) => (
                  <option key={month} value={index + 1}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="card-body">
            {loading ? (
              <p className="mb-0">Loading...</p>
            ) : error ? (
              <p className="mb-0 text-muted">{error}</p>
            ) : chartData.series.length > 0 ? (
              <div className="d-flex justify-content-center">
                <Chart
                  options={options}
                  series={chartData.series}
                  type="donut"
                  height={350}
                  width="100%"
                />
              </div>
            ) : (
              <p className="mb-0 text-muted">No top revenue hotels data available.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
